import React from 'react';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import styles from './AgChartSettings.module.scss';
import ChartOptionsSettings from './chart/ChartOptionsSettings.lazy.jsx';
import SeriesSettings from './series/SeriesSettings.lazy.jsx';
import ChartTypeSettings from './chart/ChartTypeSettings.lazy.jsx';
import DatasourceSection from '../datasource/DataSourceSection.lazy.jsx';
import FormulaFieldsSettings from './formula/FormulaFieldsSettings.jsx';

function AgChartSettings({ widgetId }) {
  return (
    <div className={styles['ag-chart-settings']}>
      <DatasourceSection widgetId={widgetId} />
      <hr />
      <CollapsibleSection title={I18n.t('chart_type')}>
        <ChartTypeSettings widgetId={widgetId} />
      </CollapsibleSection>
      <hr />
      <CollapsibleSection title={I18n.t('series_settings')}>
        <SeriesSettings widgetId={widgetId} />
      </CollapsibleSection>
      <hr />
      <CollapsibleSection title={I18n.t('formula_fields')} initialCollapsed={true}>
        <FormulaFieldsSettings widgetId={widgetId} />
      </CollapsibleSection>
      <hr />
      <CollapsibleSection title={I18n.t('content_settings')}>
        <ChartOptionsSettings widgetId={widgetId} />
      </CollapsibleSection>
    </div>
  )
}

export default AgChartSettings;
